import { Routes, Route, Navigate } from 'react-router-dom'
import appInfo from './app-info'
import routes from './app-routes'
import { DocExportProgress } from './components'
import { SideNavInnerToolbar as SideNavBarLayout } from './layouts'
import { ExportProgress as ExportProgressLayout } from './layouts'
import { useAuth } from './contexts/auth'
import NotAllowed from './NotAllowed'
import './Content.scss'

export default function Content() {
	const { notAllowed } = useAuth()
	return (
		<div className="content-wrapper">
			<ExportProgressLayout />
			<DocExportProgress />
			<SideNavBarLayout title={appInfo.title}>
				{notAllowed ? (
					<NotAllowed />
				) : (
					<Routes>
						{routes.map(({ path, element }) => (
							<Route key={path} path={path} element={element} />
						))}
						<Route path="*" element={<Navigate to="/" />} />
					</Routes>
				)}
			</SideNavBarLayout>
		</div>
	)
}
